import {Component, EventEmitter, Input, Output} from "@angular/core";
import {Contract} from "../../model/contract.interface";

@Component({
    selector: 'bm-contract-toolbar',
    templateUrl: 'bm-contract-toolbar.component.html',
    standalone: false,
})
export class BmContractToolbarComponent {
    @Input() contract!: Contract;
    @Output() close = new EventEmitter<void>();

    handleClose() {
        this.close.emit();
    }
}